{
  "UserMenu_Notifications": "Notifications",
  "UserMenu_UserTour": "Start User Education Tour",
  "UserMenu_ShowInsights": "Show Insights Dashboard",
  "UserMenu_HideInsights": "Hide Insights Dashboard",
  "UserMenu_ChangePassword": "Change Password",
  "UserMenu_ChangeLanguage": "Change Language",
  "UserMenu_Timezone": "Change Timezone",
  "UserMenu_Help": "Help",
  "UserMenu_ClearContentful": "Clear Contentful Cache",
  "UserMenu_ChangeBrowserProfile": "Change Browser Profile",
  "UserMenu_Resources": "Resources",
  "UserMenu_Resources_Terms": "Terms & Conditions",
  "UserMenu_Resources_CookiePolicy": "Cookie Policy",
  "UserMenu_Resources_PrivacyPolicy": "Privacy Policy",
  "UserMenu_Logout": "Logout",
  "NAME": "UserMenu"
}